export default __webpack_public_path__ + "static/18_32-33ee81621bda78adfa1f0633a160c5e5.png";